
// 添加类型
export const ADD_TYPE = {
    POSITION: '1', //版位
    APP_POSITION: '2', //版位+产品
}
export const ADD_TYPE_LIST = [
    {
        value: ADD_TYPE.POSITION,
        label: '按版位'
    },
    {
        value: ADD_TYPE.APP_POSITION,
        label: '按产品+版位'
    }
]
// 选择包类型
export const ADD_PACKAGE_TYPE = {
    UNIFIED: '1', //统一
    APP: '2', //产品
}
export const ADD_PACKAGE_TYPE_LIST = [
    {
        value: ADD_PACKAGE_TYPE.UNIFIED,
        label: '统一配置'
    },
    {
        value: ADD_PACKAGE_TYPE.APP,
        label: '按产品'
    }
]